export const SECONDARY_PAYMENT_RECEIVE = {
    BASE_PATH: '/secondary-sale-order/payment-receive/',
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    LIST_PAGE_TITLE: 'Secondary Sales Order List',
    EDIT_PAGE_TITLE: 'Edit Secondary Sales Order',
    GET_ALL: 'secondary-sale-order/payment-receive',
    GET_ONE: 'secondary-sale-order/payment-receive/edit/',
    CREATE: 'secondary-sale-order/payment-receive/create',
    UPDATE: 'secondary-sale-order/payment-receive/update/',
    DELETE: 'secondary-sale-order/payment-receive/delete/',
};
